export default {
    mslayer_element_count: 'not_set',
    mslayer_element_variant: 'default',
    mslayer_element_body_type: 'slider',
    mslayer_element_id: 'not_set',
    mslayer_affiliate_id: 'not_set',
    mslayer_element_detail_start_date: 'not_set',
}
